<template>
    <div class="batch-size-table">
        <div class="batch-size-table-header">
            <h3 class="batch-size-table-title">Таблица размеров партии</h3>
        </div>

        <div class="batch-size-table-controls">
            <button type="button" class="table-control-btn" @click="addRow">+ Размер</button>
            <button type="button" class="table-control-btn" @click="addCharacteristic">+ Характеристика</button>
            <label class="table-control-btn" :class="{ disabled: isRecognizing }">
                {{ isRecognizing ? 'Распознаём...' : '🖼️ Распознать по фото' }}
                <input
                    type="file"
                    accept="image/*"
                    class="table-photo-input"
                    :disabled="isRecognizing"
                    @change="recognizeFromPhoto"
                />
            </label>
        </div>

        <div v-if="rows.length" class="batch-size-table-wrapper">
            <table>
                <thead>
                    <tr>
                        <th>Размер</th>
                        <th v-for="char in characteristics" :key="char">
                            {{ char }}
                            <button type="button" class="table-remove-btn" @click="removeCharacteristic(char)">✕</button>
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, index) in rows" :key="index">
                        <td><input type="text" v-model="row.size" placeholder="S" class="table-input" /></td>
                        <td v-for="char in characteristics" :key="char">
                            <input type="text" v-model="row.values[char]" class="table-input" />
                        </td>
                        <td><button type="button" class="table-remove-btn" @click="rows.splice(index, 1)">✕</button></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-else class="batch-size-table-empty">
            Таблицы нет — покупатели не увидят ссылку «Таблица размеров» у этой партии
        </div>
    </div>
</template>

<script>
import api from '@/api/api';

export default {
    props: {
        // Только начальное значение: дальше таблицей владеет редактор и сообщает изменения через change
        initialTable: {
            type: Array,
            default: null,
        },
    },
    emits: ['change', 'error'],
    data() {
        return {
            rows: [],
            characteristics: [],
            isRecognizing: false,
        };
    },
    created() {
        this.loadTable(this.initialTable || []);
    },
    watch: {
        rows: {
            deep: true,
            handler() {
                // Строки без названия размера покупателю показывать нечего
                this.$emit('change', this.rows.filter(row => row.size && row.size.trim()));
            },
        },
    },
    methods: {
        loadTable(table) {
            this.rows = table.map(row => ({ size: row.size || '', values: { ...row.values } }));
            this.characteristics = [...new Set(this.rows.flatMap(row => Object.keys(row.values)))];
        },

        addRow() {
            const values = {};
            this.characteristics.forEach(char => { values[char] = ''; });
            this.rows.push({ size: '', values });
        },

        addCharacteristic() {
            const name = (prompt('Введите название новой характеристики:') || '').trim();
            if (!name || this.characteristics.includes(name)) return;
            this.characteristics.push(name);
            this.rows.forEach(row => { row.values[name] = ''; });
        },

        removeCharacteristic(name) {
            if (!confirm(`Удалить характеристику "${name}"?`)) return;
            this.characteristics = this.characteristics.filter(char => char !== name);
            this.rows.forEach(row => { delete row.values[name]; });
        },

        async recognizeFromPhoto(event) {
            const file = event.target.files[0];
            if (!file) return;

            if (file.size > 8 * 1024 * 1024) {
                this.$emit('error', 'Файл слишком большой. Максимальный размер: 8MB');
                event.target.value = '';
                return;
            }

            this.isRecognizing = true;
            try {
                const photoFormData = new FormData();
                photoFormData.append('photo', file);

                const response = await api.post('/bot_managment/size-table/recognize', photoFormData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
                this.loadTable(response.data.size_table);
            } catch (error) {
                this.$emit('error', error.response?.data?.detail || 'Не удалось распознать таблицу на фото');
            } finally {
                this.isRecognizing = false;
                event.target.value = '';
            }
        },
    },
};
</script>

<style scoped>
.batch-size-table {
    margin-top: 16px;
}

.batch-size-table-title {
    font-size: 14px;
    color: #e0e0e0;
    margin-bottom: 10px;
}

.batch-size-table-controls {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 10px;
}

.table-control-btn {
    padding: 8px 12px;
    background: rgba(37, 165, 240, 0.1);
    border: 1px solid rgba(37, 165, 240, 0.3);
    border-radius: 8px;
    color: #25A5F0;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
}

.table-control-btn.disabled {
    opacity: 0.5;
    cursor: default;
}

.table-photo-input {
    display: none;
}

.batch-size-table-wrapper {
    overflow-x: auto;
}

table {
    border-collapse: collapse;
    color: #e0e0e0;
    font-size: 13px;
}

th {
    padding: 6px;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
}

td {
    padding: 3px;
}

.table-input {
    width: 72px;
    padding: 8px;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    color: #ffffff;
    font-size: 14px;
}

.table-input:focus {
    outline: none;
    border-color: #25A5F0;
}

.table-remove-btn {
    padding: 2px 6px;
    background: none;
    border: none;
    color: #ff6b6b;
    cursor: pointer;
}

.batch-size-table-empty {
    font-size: 12px;
    color: #a0a0a0;
}
</style>
